/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { getUserLocalesInternal } from "./locale";

export function trimText(c: string, l: number) {
  return c.length > l ? `${c.slice(0, Math.max(0, l))}...` : c;
}

export function trimTextBeginning(c: string | null | undefined, l: number) {
  return (
    (c && (c.length > l ? `...${c.slice(Math.max(0, c.length - l))}` : c)) ?? ""
  );
}

export function inflect(singular: string, plural = `${singular}s`) {
  return (quantity: number) => (Math.abs(quantity) === 1 ? singular : plural);
}

export function formatNumberToLocaleString(num: number) {
  return num.toLocaleString(getUserLocalesInternal());
}

export function joinSentenceSubjects(
  subjects: { subject: string; count: number }[]
) {
  const nonZeroCountSubjects = subjects.filter(({ count }) => count > 0);
  return nonZeroCountSubjects
    .reduce<string[]>((acc, curr, index) => {
      const isFirst = index === 0;
      const isLast = index === nonZeroCountSubjects.length - 1;

      const separator = getSeparator(isFirst, isLast);
      const count = `${curr.count} `;
      const noun = inflect(curr.subject)(curr.count);

      return [...acc, `${separator}${count}${noun}`];
    }, [])
    .join("");
}

function getSeparator(isFirst: boolean, isLast: boolean) {
  if (isFirst) {
    return "";
  }

  if (isLast) {
    return " and ";
  }

  return ", ";
}
